<template>
  <v-app>
    <core-app-bar />

    <core-drawer />

    <core-payment-information-view />

    <core-footer />

  </v-app>
</template>

<script>
export default {
  name: 'PaymentInformation',

  components: {
    CoreAppBar: () => import('../components/core/AppBar'),
    CoreDrawer: () => import('../components/core/Drawer'),
    CorePaymentInformationView: () => import('../components/core/PaymentInformationView'),
    CoreFooter: () => import('../components/core/Footer'),
  },

  data: () => ({
    expandOnHover: false,
  }),
}
</script>
